import React from "react";

export const AboutPage: React.FC = () => {
  return (
    <main className="page about-page">
      <section className="about-hero">
        <div className="about-hero__inner">
          <p className="eyebrow">Обо мне</p>
          <h1>Оганов Владислав Виленович</h1>
          <p className="about-hero__subtitle">
            Врач-невролог, мануальный терапевт и психотерапевт
          </p>
        </div>
      </section>

      <section className="about-content">
        <div className="about-content__inner">
          <div className="about-text">
            <p>
              Здравствуйте! Меня зовут Оганов Владислав Виленович, я врач-невролог, мануальный терапевт и
              психотерапевт.
            </p>
            <p>
              Моя профессиональная деятельность находится на пересечении неврологии и психотерапии. Двойное
              полноценное профессиональное образование в этих направлениях позволяет мне не только лечить физические
              проявления болезни, но и понимать глубинные психологические механизмы, которые нередко лежат в основе
              хронической боли и других неврологических расстройств.
            </p>
            <p>
              Параллельно с медицинским образованием я с самого начала стремился к более глубокому пониманию
              психологии человека. В 2017 году, сразу после окончания университета, прошёл базовый курс «Основы
              психологического консультирования и психоаналитической диагностики» для врачей в Московском институте
              психоанализа. Это заложило фундамент для последующего изучения когнитивно-поведенческой и
              психоаналитически ориентированной терапии, а также регулярной личной психоаналитической работы, которую
              я веду с 2018 года.
            </p>
            <p>
              Мой практический опыт складывался не только в амбулаторной, но и в клинической стационарной работе.
              После окончания ординатуры по неврологии до 2021 года я работал врачом-неврологом в Клинике нервных
              болезней им. А. Я. Кожевникова — одном из ведущих специализированных неврологических учреждений России.
              Этот опыт дал мне возможность наблюдать широкий спектр неврологических патологий, глубоко разобраться в
              клинической картине заболеваний и научиться принимать взвешенные решения в сложных ситуациях. В
              настоящее время я продолжаю консультировать пациентов и использовать полученные знания в частной
              практике.
            </p>
            <p>
              Сочетание медицинского и психологического подходов, подкреплённое клиническим опытом, позволяет
              эффективно работать как с болевыми синдромами различной локализации и этиологии, так и с тревожными и
              депрессивными расстройствами, психосоматическими заболеваниями и последствиями стресса. Самыми частыми
              жалобами, с которыми ко мне обращаются пациенты, являются: боли в спине, головные боли, головокружение,
              панические атаки, подавленное настроение, нарушение сна, кардионевроз, межличностные и
              детско-родительские конфликты, сопровождающиеся выраженными эмоциональными переживаниями — чувством
              обиды, вины, стыда, страхом оценки, ипохондрическими переживаниями и различными формами зависимости.
            </p>
            <p>
              В своей работе я придерживаюсь принципов доказательной медицины и научно обоснованных
              психотерапевтических подходов. Когнитивно-поведенческая терапия помогает справляться с актуальными
              симптомами и дезадаптивными моделями поведения, проявляющимися «здесь и сейчас», в то время как
              психоаналитически ориентированная терапия позволяет глубже понять и проработать внутренние конфликты,
              повторяющиеся жизненные сценарии и бессознательные процессы, влияющие на качество жизни и общее
              состояние здоровья.
            </p>
            <p>
              При всём многообразии современных методов лечения, в своих статьях я делюсь наиболее эффективными из
              них — теми, что действительно помогают: где можно справиться самостоятельно, а где нужно незамедлительно
              обратиться к специалисту.
            </p>
            <p>
              Такой комплексный подход позволяет быстрее достичь стойкого улучшения с минимальными побочными
              эффектами. В зависимости от клинической ситуации лечение может включать: таблетированную или
              инъекционную фармакотерапию (в том числе лечебные блокады), сеансы мануальной терапии, индивидуальные
              схемы лечебных упражнений, а также психотерапевтические сессии, основанные на принципах
              когнитивно-поведенческой и глубинной аналитической терапии.
            </p>
          </div>

          <div className="about-section">
            <h2>Образование</h2>
            <ul className="about-list">
              <li>2017 г. — окончил ФГАОУ ВО Первый МГМУ им. И.М. Сеченова Минздрава России (Сеченовский Университет)</li>
              <li>2017 г. — курс повышения квалификации «Основы психологического консультирования и психоаналитической диагностики» в Московском Институте Психоанализа (МИП)</li>
              <li>2018 г. — курс повышения квалификации по медицинской психологии в Институте психотерапии и клинической психологии</li>
              <li>2019 г. — клиническая ординатура по специальности «Неврология», ФГАОУ ВО Первый МГМУ им. И.М. Сеченова</li>
              <li>2019 г. — цикл усовершенствования «Интервенционные методы локального инъекционного лечения боли», Кафедра неврологии, Первый МГМУ им. И.М. Сеченова</li>
              <li>2019 г. — Университетская клиническая больница №3, Клиника нервных болезней им. А.Я. Кожевникова, Первый МГМУ им. И.М. Сеченова: врач-невролог, мануальный терапевт</li>
              <li>2019 г. — Российская академия образования: «Когнитивно-поведенческая психотерапия»; «Психоанализ, аналитически ориентированная психотерапия»</li>
              <li>2020 г. — цикл «Междисциплинарный подход в лечении боли», Кафедра неврологии, Первый МГМУ им. И.М. Сеченова</li>
              <li>2020 г. — цикл «Неврологические осложнения новой коронавирусной инфекции COVID-19», Кафедра РУДН</li>
              <li>2021 г. — цикл «Принципы кинезиотейпирования», Кафедра неврологии, Первый МГМУ им. И.М. Сеченова</li>
              <li>2021 г. — проведение семинаров по локальному инъекционному лечению боли и кинезиотейпированию для врачей различных специальностей, Клиника нервных болезней им. А.Я. Кожевникова, Первый МГМУ им. И.М. Сеченова</li>
              <li>2021 г. — повторный цикл «Междисциплинарный подход в лечении боли», Кафедра неврологии, Первый МГМУ им. И.М. Сеченова</li>
              <li>2024 г. — окончание МУППИ, психолого-педагогический факультет</li>
            </ul>
          </div>

          <div className="about-section">
            <h2>Участие в научно-практических конференциях</h2>
            <ul className="about-list">
              <li>Конференция по нейропсихологии и неврологии в рамках ежегодного конгресса неврологов России, 2022 г.</li>
              <li>Международная конференция по психосоматике и боли, 2021 г.</li>
              <li>Научно-практическая конференция по когнитивно-поведенческой терапии, 2023 г.</li>
            </ul>
          </div>

          <div className="about-section">
            <h2>Консультации и лечение пациентов с различными проблемами</h2>

            <h3>Неврологические расстройства:</h3>
            <ul className="about-list">
              <li>Боль в спине (все отделы позвоночника)</li>
              <li>Хроническая боль в области таза</li>
              <li>Хроническая лицевая боль</li>
              <li>Головные боли и головокружение</li>
              <li>Грыжа межпозвоночного диска</li>
              <li>Рассеянный склероз</li>
              <li>Онемение в руках или ногах</li>
              <li>Нарушения осанки и неустойчивость при ходьбе</li>
              <li>Поражения головного и спинного мозга</li>
              <li>Сосудистые заболевания нервной системы</li>
            </ul>

            <h3>Эмоциональные, психосоматические и поведенческие расстройства:</h3>
            <ul className="about-list">
              <li>Тревожно-депрессивные расстройства</li>
              <li>Панические атаки</li>
              <li>Подавленное настроение и нарушение сна</li>
              <li>Кардионевроз</li>
              <li>Ипохондрические переживания</li>
              <li>Межличностные и детско-родительские конфликты, сопровождающиеся чувством обиды, вины, стыда и страхом оценки</li>
              <li>Различные формы зависимости</li>
            </ul>
          </div>

          <div className="about-section">
            <h2>Достижения</h2>
            <ul className="about-list">
              <li>Член Российского межрегионального общества по изучению боли (РОИБ)</li>
              <li>Член Russian Association for the Study of Pain (RASP)</li>
              <li>Член Российской ассоциации когнитивно-поведенческой психотерапии</li>
              <li>Член Российского сообщества психоаналитической психотерапии</li>
              <li>Победитель Всероссийской премии «Продокторов» среди неврологов (2021)</li>
              <li>Участник российских и международных научно-практических конференций, форумов и семинаров</li>
            </ul>
          </div>
        </div>
      </section>
    </main>
  );
};
